// Third-party
import Coordinate from '@/types/coordinate';
import Dimensions from '@/types/dimensions';
import React, { CSSProperties } from 'react';

type Props = {
  style: CSSProperties;
  center: Coordinate;
  container: Dimensions;
  color: string;
  strokeWidth: number;
};

const Crosshair = ({ center, container, color, strokeWidth = 1, style }: Props) => {
  const groupProps = {
    style,
    className: 'crosshair',
    'data-z-index': 4,
  };

  return (
    <g {...groupProps}>
      <line className="crosshair-x" stroke={color} strokeWidth={strokeWidth} x1="0" y1={center.y} x2={container.width} y2={center.y} />
      <line className="crosshair-y" stroke={color} strokeWidth={strokeWidth} x1={center.x} y1="0" x2={center.x} y2={container.height} />
    </g>
  );
};

export default Crosshair;
